import 'vendor/cocoon';
import 'vendor/easy-autocomplete';
import 'tempusdominus-bootstrap-4';
import Cleave from 'cleave.js';
import OnloadHandler from 'onload_handler';
import { WarehouseKind } from 'enumerations.js.erb';
import numeral from 'numeral';

(function () {

  const ProductForm = function(){

      var goldShareField,
          grossWeightField,
          netWeightField,
          form;

      function pf(){
      };

      function cleanupShareError(){
        goldShareField.removeClass('is-invalid');
        goldShareField.parent().find('.gold-share-error').remove();        
      }
      function checkConsistencyAndUpdate(){
        var goldShare = +goldShareField.val();
        var grossWeight = +grossWeightField.val();
        var netWeight = +netWeightField.val();
        
        if (!goldShare && grossWeight && netWeight) {
          goldShare = _.round((netWeight/grossWeight)*1000, 2);
          goldShareField.val(goldShare);
        }
        if (goldShare && !grossWeight && netWeight) {
          grossWeight = _.round((netWeight*1000)/goldShare, 4);
          grossWeightField.val(grossWeight);
        }
        if (goldShare && grossWeight && !netWeight) {
          netWeight = _.round((grossWeight*goldShare)/1000, 4);
          netWeightField.val(netWeight);
        }
        if (goldShare && grossWeight && netWeight) {
          var correctGoldShare = _.round((netWeight/grossWeight)*1000, 2);
          cleanupShareError();
          if (correctGoldShare != _.round(goldShare, 2)){
            goldShareField.addClass('is-invalid');
            var error = $('<div>').
                          addClass('invalid-feedback').
                          addClass('gold-share-error').
                          html('Il titolo non è consistente con i pesi inseriti');
            goldShareField.parent().append(error);
          }         
        }
      }


      pf.setup = function(formselector, fieldfilter) {
        form = $(formselector);
        goldShareField = form.find('.gold-share');
        var grossFieldSelector = goldShareField.data('gross-field');
        var netFieldSelector = goldShareField.data('net-field');
        if (grossFieldSelector && netFieldSelector) {
          grossWeightField = form.find(grossFieldSelector);
          netWeightField = form.find(netFieldSelector);
          
          goldShareField.on('change', checkConsistencyAndUpdate);
          grossWeightField.on('change', checkConsistencyAndUpdate);
          netWeightField.on('change', checkConsistencyAndUpdate);
        }

        cleanupShareError();
        checkConsistencyAndUpdate();
      }

      return pf;
  };
  window.ProductForm = ProductForm;

  OnloadHandler(function(){
    _.each($('.product-form'), function(el){
      ProductForm().setup(el);
    });
  })


})()